import { BaseError } from "@/domains/errors";
import { objectModule } from "@/modules/object";
import { api } from "@/modules/api";
import { logger } from "@/modules/logger";

interface OAuthConsentArgs {
  clientId: string;
  redirectUri: string;
  scope: string;
  state: string;
}

export const approveOAuthConsent = async ({
  clientId,
  redirectUri,
  scope,
  state,
}: OAuthConsentArgs) => {
  const response = await api.post("/v2/oauth2/consent/approve", {
    body: {
      client_id: clientId,
      redirect_uri: redirectUri,
      scope,
      state,
      response_type: "code",
    },
  });

  if (response.error) {
    const err = new BaseError({
      message: "[oauthModule] [approveOAuthConsent] Failed.",
      info: { result: objectModule.safeAsJson(response) },
    });

    throw err;
  }

  return response.data;
};

export const denyOAuthConsent = async ({
  clientId,
  redirectUri,
  scope,
  state,
}: OAuthConsentArgs) => {
  const response = await api.post("/v2/oauth2/consent/deny", {
    body: {
      client_id: clientId,
      redirect_uri: redirectUri,
      scope,
      state,
      response_type: "code",
    },
  });

  if (response.error) {
    const err = new BaseError({
      message: "[oauthModule] [denyOAuthConsent] Failed.",
      info: { result: objectModule.safeAsJson(response) },
    });

    logger.error({
      message: "[oauthModule] [denyOAuthConsent] Failed.",
      info: { error: err.message },
    });

    throw err;
  }

  return response.data;
};
